import React, { useState, useEffect } from 'react';
import Loader from 'shared/common/loader';
import DocumentUpload from './document-upload';
import PanCardUpload from './pan-card-upload';
import KYCDetails from './KYCDetails';
import BankForm from './BankForm';
import UPIForm from './UPIForm';
import { userStore } from '../../../store/UserStore';
import { Alert } from 'react-bootstrap';

interface PropsType {
  user: any;
  customer: any;
}

const BankDetails: React.FC<PropsType> = ({ user, customer }) => {
  const [loading, setLoading] = useState(true);
  const [docShow, setDocShow] = useState(false);
  const [uploadShow, setUploadShow] = useState(false);
  const [customerState, setCustomer] = userStore((state: any) => [state.customer, state.setCustomer]);

  useEffect(() => {
    setLoading(false);
  }, []);


  // console.log(customerState,"@customerState");

  const isPanVerified = customerState?.kyc?.pan?.isVerified === true;

  return (
    <>
      {loading && <Loader />}
      <DocumentUpload handleModal={setDocShow} isShow={docShow} customerId={customer.customerId} />
      <PanCardUpload handleModal={setUploadShow} isShow={uploadShow} customerId={customer.customerId} />
      <KYCDetails />

      <div
        style={{
          pointerEvents: isPanVerified ? 'auto' : 'none',
          opacity: isPanVerified ? 1 : 0.5,
          transition: 'opacity 0.3s ease',
        }}
      >
        <BankForm customer={customerState} user={user} setCustomer={setCustomer} />
        <UPIForm customer={customerState} user={user} setCustomer={setCustomer} />
      </div>
    </>
  );
};

export default BankDetails;
